module.exports = __webpack_public_path__ + "static/media/bez_temp_w_domu_czuwanie_3.e1ae5c79.svg";